import React from "react";
import { Box } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

const Loader = ({ Text }) => {
    return (
        <Box
            sx={{
                textAlign: "left",
                display: "flex",
                alignItems: "center",
            }}
        >
            <CircularProgress size={17} />
            <Typography sx={{ ml: "10px" }}>{Text}</Typography>
        </Box>
    );
};

export default Loader;
